module.exports = __webpack_public_path__ + "static/media/Computer_ventilator.a4407b9f.mp3";